export default (x) => x.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
